export default "__VITE_ASSET__8e0c602d__"